import { isMarketingRouteActive } from './marketing-navigation';

// Shared destinations keep the desktop and mobile menus in sync.
export const resourceNavigationGroups = [
  {
    label: 'Research guides',
    links: [
      { href: '/people-and-company-intelligence', label: 'Category overview' },
      { href: '/buyer-intent-signals', label: 'Buyer intent signals' },
      { href: '/continuous-account-research', label: 'Continuous research' }
    ]
  },
  {
    label: 'Use cases',
    links: [
      {
        href: '/use-cases/sales-prioritization',
        label: 'Sales prioritization'
      },
      {
        href: '/use-cases/named-account-research',
        label: 'Named-account research'
      },
      { href: '/use-cases/new-market-entry', label: 'New-market entry' }
    ]
  },
  {
    label: 'Compare Lumnis',
    links: [
      { href: '/compare', label: 'All comparisons' },
      {
        href: '/compare/lumnis-vs-linkedin-sales-navigator',
        label: 'vs LinkedIn Sales Navigator'
      },
      { href: '/compare/lumnis-vs-clay', label: 'vs Clay' },
      { href: '/compare/lumnis-vs-common-room', label: 'vs Common Room' },
      { href: '/compare/lumnis-vs-zoominfo', label: 'vs ZoomInfo' },
      { href: '/compare/lumnis-vs-6sense', label: 'vs 6sense' }
    ]
  }
] as const;

export const resourceUtilityLinks = [
  { href: '/blog', label: 'Blog' },
  { href: '/docs', label: 'Docs' }
] as const;

export function isResourceNavigationActive(pathname: string): boolean {
  return (
    pathname === '/resources' ||
    resourceUtilityLinks.some((link) =>
      isMarketingRouteActive(pathname, link.href)
    ) ||
    resourceNavigationGroups.some((group) =>
      group.links.some((link) => link.href === pathname)
    )
  );
}
